import isPlainObject from 'lodash-es/isPlainObject';
import isMap from 'lodash-es/isMap';
import hasGeneratorInterface from './hasGeneratorInterface';
import flattenWhenNode from './flattenWhenNode';

export default flattenWhenNode(function (node) {
  return (isPlainObject(node) || isMap(node)) && !hasGeneratorInterface(node);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-actions/es/utils/flattenReducerMap.js
// module id = 1386
// module chunks = 7